import { signatures } from './constants/constants';

export const detectMimeType = (b64: string) => {
  for (const s in signatures) {
    if (b64.indexOf(s) === 0) {
      return signatures[s];
    }
  }
};
